import { useQuery, useMutation } from "@tanstack/react-query";
import { instanceWithToken } from "../../axios.config";

export const useShippingOptions = () => {
  return useQuery({
    queryKey: ["shippingOptions"],
    queryFn: async () => {
      const {
        data: { data },
      } = await instanceWithToken.get("shipping");
      return data;
    },
  });
};

export const useShipping = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("shipping", body);
      return data;
    },
  });
};

export const usePayment = (isSuccess) => {
  return useQuery({
    queryKey: ["shippingPayment"],
    queryFn: async () => {
      if (isSuccess) {
        const {
          data: { data },
        } = await instanceWithToken.get("payment/getToken");
        return data;
      }
    },
  });
};
